const categoryMap = {
  people: {
    '😀': ['grinning'],
    '😬': ['grimacing'],
    '😁': ['grin'],
    '😂': ['joy'],
    '😃': ['smiley'],
    '😄': ['smile'],
    '😅': ['sweat_smile'],
    '😆': ['laughing', 'satisfied'],
    '😇': ['innocent'],
    '😉': ['wink'],
    '😊': ['blush'],
    '🙂': ['slight_smile', 'slightly_smiling_face'],
    '🙃': ['upside_down', 'upside_down_face'],
    '☺': ['relaxed'],
    '😋': ['yum'],
    '😌': ['relieved'],
    '😍': ['heart_eyes'],
    '😘': ['kissing_heart'],
    '😗': ['kissing'],
    '😙': ['kissing_smiling_eyes'],
    '😚': ['kissing_closed_eyes'],
    '😜': ['stuck_out_tongue_winking_eye'],
    '😝': ['stuck_out_tongue_closed_eyes'],
    '😛': ['stuck_out_tongue'],
    '🤑': ['money_mouth', 'money_mouth_face'],
    '🤓': ['nerd', 'nerd_face'],
    '😎': ['sunglasses'],
    '🤗': ['hugging', 'hugging_face'],
    '😏': ['smirk'],
    '😶': ['no_mouth'],
    '😐': ['neutral_face'],
    '😑': ['expressionless'],
    '😒': ['unamused'],
    '🙄': ['rolling_eyes', 'face_with_rolling_eyes'],
    '🤔': ['thinking', 'thinking_face'],
    '😳': ['flushed'],
    '😞': ['disappointed'],
    '😟': ['worried'],
    '😠': ['angry'],
    '😡': ['rage'],
    '😔': ['pensive'],
    '😕': ['confused'],
    '🙁': ['slight_frown', 'slightly_frowning_face'],
    '☹': ['frowning2', 'white_frowning_face'],
    '😣': ['persevere'],
    '😖': ['confounded'],
    '😫': ['tired_face'],
    '😩': ['weary'],
    '😤': ['triumph'],
    '😮': ['open_mouth'],
    '😱': ['scream'],
    '😨': ['fearful'],
    '😰': ['cold_sweat'],
    '😯': ['hushed'],
    '😦': ['frowning'],
    '😧': ['anguished'],
    '😢': ['cry'],
    '😥': ['disappointed_relieved'],
    '😪': ['sleepy'],
    '😓': ['sweat'],
    '😭': ['sob'],
    '😵': ['dizzy_face'],
    '😲': ['astonished'],
    '🤐': ['zipper_mouth', 'zipper_mouth_face'],
    '😷': ['mask'],
    '🤒': ['thermometer_face', 'face_with_thermometer'],
    '🤕': ['head_bandage', 'face_with_head_bandage'],
    '😴': ['sleeping'],
    '💤': ['zzz'],
    '💩': ['poop', 'shit', 'hankey', 'poo'],
    '😈': ['smiling_imp'],
    '👿': ['imp'],
    '👹': ['japanese_ogre'],
    '👺': ['japanese_goblin'],
    '💀': ['skull', 'skeleton'],
    '👻': ['ghost'],
    '👽': ['alien'],
    '🤖': ['robot', 'robot_face'],
    '😺': ['smiley_cat'],
    '😸': ['smile_cat'],
    '😹': ['joy_cat'],
    '😻': ['heart_eyes_cat'],
    '😼': ['smirk_cat'],
    '😽': ['kissing_cat'],
    '🙀': ['scream_cat'],
    '😿': ['crying_cat_face'],
    '😾': ['pouting_cat'],
    '🙌': ['raised_hands'],
    '👏': ['clap'],
    '👋': ['wave'],
    '👍': ['thumbsup', '+1', 'thumbup'],
    '👎': ['thumbsdown', '-1', 'thumbdown'],
    '👊': ['punch'],
    '✊': ['fist'],
    '✌': ['v'],
    '👌': ['ok_hand'],
    '✋': ['raised_hand'],
    '👐': ['open_hands'],
    '💪': ['muscle'],
    '🙏': ['pray'],
    '☝': ['point_up'],
    '👆': ['point_up_2'],
    '👇': ['point_down'],
    '👈': ['point_left'],
    '👉': ['point_right'],
    '🖕': ['middle_finger', 'reversed_hand_with_middle_finger_extended'],
    '🖐': ['hand_splayed', 'raised_hand_with_fingers_splayed'],
    '🤘': ['metal', 'sign_of_the_horns'],
    '🖖': ['vulcan', 'raised_hand_with_part_between_middle_and_ring_fingers'],
    '✍': ['writing_hand'],
    '💅': ['nail_care'],
    '👄': ['lips'],
    '👅': ['tongue'],
    '👂': ['ear'],
    '👃': ['nose'],
    '👁': ['eye'],
    '👀': ['eyes'],
    '👤': ['bust_in_silhouette'],
    '👥': ['busts_in_silhouette'],
    '🗣': ['speaking_head', 'speaking_head_in_silhouette'],
    '👶': ['baby'],
    '👦': ['boy'],
    '👧': ['girl'],
    '👨': ['man'],
    '👩': ['woman'],
    '👱': ['person_with_blond_hair'],
    '👴': ['older_man'],
    '👵': ['older_woman', 'grandma'],
    '👲': ['man_with_gua_pi_mao'],
    '👳': ['person_with_turban'],
    '👮': ['cop'],
    '👷': ['construction_worker'],
    '💂': ['guard', 'foot_guard'],
    '🕵': ['spy', 'sleuth_or_spy', 'detective'],
    '🎅': ['santa'],
    '👼': ['angel'],
    '👸': ['princess'],
    '👰': ['bride_with_veil'],
    '🚶': ['walking', 'pedestrian'],
    '🏃': ['runner'],
    '💃': ['dancer', 'woman_dancer', 'woman_dancing'],
    '👯': ['dancers', 'people_with_bunny_ears'],
    '👫': ['couple'],
    '👬': ['two_men_holding_hands'],
    '👭': ['two_women_holding_hands'],
    '🙇': ['bow'],
    '💁': ['information_desk_person'],
    '🙅': ['no_good', 'person_no'],
    '🙆': ['ok_person', 'gesture_ok'],
    '🙋': ['raising_hand'],
    '🙎': ['person_with_pouting_face'],
    '🙍': ['person_frowning'],
    '💇': ['haircut'],
    '💆': ['massage'],
    '💑': ['couple_with_heart'],
    '👩‍❤️‍👩': ['couple_ww', 'couple_with_heart_ww'],
    '👨‍❤️‍👨': ['couple_mm', 'couple_with_heart_mm'],
    '💏': ['couplekiss'],
    '👩‍❤️‍💋‍👩': ['kiss_ww', 'couplekiss_ww'],
    '👨‍❤️‍💋‍👨': ['kiss_mm', 'couplekiss_mm'],
    '👪': ['family'],
    '👨‍👩‍👧': ['family_mwg'],
    '👨‍👩‍👧‍👦': ['family_mwgb'],
    '👨‍👩‍👦‍👦': ['family_mwbb'],
    '👨‍👩‍👧‍👧': ['family_mwgg'],
    '👩‍👩‍👦': ['family_wwb'],
    '👩‍👩‍👧': ['family_wwg'],
    '👩‍👩‍👧‍👦': ['family_wwgb'],
    '👩‍👩‍👦‍👦': ['family_wwbb'],
    '👩‍👩‍👧‍👧': ['family_wwgg'],
    '👨‍👨‍👦': ['family_mmb'],
    '👨‍👨‍👧': ['family_mmg'],
    '👨‍👨‍👧‍👦': ['family_mmgb'],
    '👨‍👨‍👦‍👦': ['family_mmbb'],
    '👨‍👨‍👧‍👧': ['family_mmgg'],
    '👨‍👦': ['family_mb'],
    '👨‍👦‍👦': ['family_mbb'],
    '👨‍👧': ['family_mg'],
    '👨‍👧‍👦': ['family_mgb'],
    '👨‍👧‍👧': ['family_mgg'],
    '👩‍👦': ['family_wb'],
    '👩‍👦‍👦': ['family_wbb'],
    '👩‍👧': ['family_wg'],
    '👩‍👧‍👦': ['family_wgb'],
    '👩‍👧‍👧': ['family_wgg'],
    '👚': ['womans_clothes'],
    '👕': ['shirt'],
    '👖': ['jeans'],
    '👔': ['necktie'],
    '👗': ['dress'],
    '👙': ['bikini'],
    '👘': ['kimono'],
    '💄': ['lipstick'],
    '💋': ['kiss'],
    '👣': ['footprints'],
    '👠': ['high_heel'],
    '👡': ['sandal'],
    '👢': ['boot'],
    '👞': ['mans_shoe'],
    '👟': ['athletic_shoe'],
    '👒': ['womans_hat'],
    '🎩': ['tophat'],
    '⛑': ['helmet_with_cross', 'helmet_with_white_cross'],
    '🎓': ['mortar_board'],
    '👑': ['crown'],
    '🎒': ['school_satchel'],
    '👝': ['pouch'],
    '👛': ['purse'],
    '👜': ['handbag'],
    '💼': ['briefcase'],
    '👓': ['eyeglasses'],
    '🕶': ['dark_sunglasses'],
    '💍': ['ring'],
    '🌂': ['closed_umbrella'],
    '🤠': ['cowboy', 'face_with_cowboy_hat'],
    '🤡': ['clown', 'clown_face'],
    '🤢': ['nauseated_face', 'sick'],
    '🤣': ['rofl', 'rolling_on_the_floor_laughing'],
    '🤤': ['drooling_face', 'drool'],
    '🤥': ['lying_face', 'liar'],
    '🤧': ['sneezing_face', 'sneeze'],
    '🤴': ['prince'],
    '🤵': ['man_in_tuxedo'],
    '🤶': ['mrs_claus', 'mother_christmas'],
    '🤦': ['face_palm', 'facepalm'],
    '🤷': ['shrug'],
    '🤰': ['pregnant_woman', 'expecting_woman'],
    '🤳': ['selfie'],
    '🕺': ['man_dancing', 'male_dancer'],
    '🤙': ['call_me', 'call_me_hand'],
    '🤚': ['raised_back_of_hand', 'back_of_hand'],
    '🤛': ['left_facing_fist', 'left_fist'],
    '🤜': ['right_facing_fist', 'right_fist'],
    '🤝': ['handshake', 'shaking_hands'],
    '🤞': ['fingers_crossed', 'hand_with_index_and_middle_finger_crossed'],
    '🤩': ['star_struck', 'starstruck', 'star_eyes'],
    '🤨': ['raised_eyebrow', 'colbert', 'skeptical'],
    '🤯': ['exploding_head', 'mindblown', 'mind_blown'],
    '🤪': ['zany', 'crazy'],
    '🤬': ['swearing', 'grawlixes', 'cursing', 'cussing'],
    '🤮': ['vomiting', 'vomit', 'throw_up'],
    '🤫': ['shush', 'shhh'],
    '🤭': ['hand_over_mouth'],
    '🧐': ['monocle'],
    '🥰': ['face_with_hearts'],
    '🥵': ['hot_face', 'hot'],
    '🥶': ['cold_face', 'freezing_face', 'freezing', 'cold'],
    '🥳': ['partying_face', 'partying'],
    '🥴': ['woozy_face', 'woozy'],
    '🥺': [
      'pleading_face',
      'begging_face',
      'pleading',
      'begging',
      'puppy_dog_eyes'
    ],
    '🧒': ['child', 'kid'],
    '🧑': ['adult'],
    '🧓': ['older_adult', 'old'],
    '🧕': ['headscarf', 'woman_with_headscarf'],
    '🧔': ['bearded_person', 'beard'],
    '🤱': ['breast_feeding'],
    '🧙': ['mage'],
    '🧙‍♂️': ['man_mage', 'wizard', 'sorcerer'],
    '🧙‍♀️': ['woman_mage', 'witch', 'sorceress'],
    '🧚': ['fairy'],
    '🧚‍♀️': ['woman_fairy'],
    '🧚‍♂️': ['man_fairy'],
    '🧛': ['vampire'],
    '🧛‍♂️': ['man_vampire', 'dracula'],
    '🧛‍♀️': ['woman_vampire'],
    '🧜': ['merperson'],
    '🧜‍♀️': ['mermaid', 'mergirl', 'merwoman'],
    '🧜‍♂️': ['merman', 'merboy'],
    '🧝': ['elf'],
    '🧝‍♀️': ['woman_elf'],
    '🧝‍♂️': ['man_elf'],
    '🧞': ['genie', 'djinn'],
    '🧞‍♀️': ['woman_genie'],
    '🧞‍♂️': ['man_genie'],
    '🧟': ['zombie', 'undead', 'walking_dead'],
    '🧟‍♀️': ['woman_zombie'],
    '🧟‍♂️': ['man_zombie'],
    '🧖': ['steamy_room', 'sauna'],
    '🧖‍♂️': ['man_in_steamy_room', 'man_in_sauna'],
    '🧖‍♀️': ['woman_in_steamy_room', 'woman_in_sauna'],
    '🧗': ['climbing', 'rock_climbing'],
    '🧗‍♀️': ['woman_climbing', 'man_rock_climbing'],
    '🧗‍♂️': ['man_climbing', 'man_rock_climbing'],
    '🧘': ['lotus_position', 'meditation', 'yoga'],
    '🧘‍♂️': ['man_lotus_position', 'man_meditation', 'man_yoga'],
    '🧘‍♀️': ['woman_lotus_position', 'woman_meditation', 'woman_yoga'],
    '🤟': ['love_you', 'ily'],
    '🤲': ['palms_together', 'dua', 'cupped_hands'],
    '🧠': ['brain'],
    '🧣': ['scarf'],
    '🧤': ['gloves'],
    '🧥': ['coat', 'jacket'],
    '🧦': ['socks'],
    '🧢': ['cap', 'baseball_cap'],
    '👨‍🦰': ['man_red_hair', 'man_redhead'],
    '👩‍🦰': ['woman_red_hair', 'woman_redhead'],
    '👩‍🦱': ['woman_curly_hair'],
    '👨‍🦱': ['man_curly_hair'],
    '👩‍🦳': ['woman_white_hair'],
    '👨‍🦳': ['man_white_hair'],
    '👩‍🦲': ['bald_woman'],
    '👨‍🦲': ['bald_man'],
    '🦸': ['superhero'],
    '🦸‍♂️': ['man_superhero'],
    '🦸‍♀️': ['woman_superhero'],
    '🦹': ['supervillain'],
    '🦹‍♂️': ['man_supervillain'],
    '🦹‍♀️': ['woman_supervillain'],
    '🦵': ['leg', 'kick'],
    '🦶': ['foot', 'stomp'],
    '🦴': ['bone'],
    '🦷': ['tooth'],
    '🥽': ['goggles', 'safety_goggles'],
    '🥼': ['lab_coat', 'labcoat', 'doctor', 'scientist'],
    '🥾': ['hiking_boot'],
    '🥿': ['flat_shoe', 'slipper'],
    '🤵‍♀️': ['woman_in_tuxedo'],
    '🕴️‍♀️': ['woman_levitate'],
    '👨‍⚕️': ['man_health_worker', 'man_doctor'],
    '👩‍⚕️': ['woman_health_worker', 'woman_doctor'],
    '👨‍🎓': ['man_student'],
    '👩‍🎓': ['woman_student'],
    '👨‍🏫': ['man_teacher'],
    '👩‍🏫': ['woman_teacher'],
    '👨‍⚖️': ['man_judge'],
    '👩‍⚖️': ['woman_judge'],
    '👨‍🌾': ['man_farmer'],
    '👩‍🌾': ['woman_farmer'],
    '👨‍🍳': ['man_cook'],
    '👩‍🍳': ['woman_cook'],
    '👨‍🔧': ['man_mechanic'],
    '👩‍🔧': ['woman_mechanic'],
    '👨‍🏭': ['man_factory_worker'],
    '👩‍🏭': ['woman_factory_worker'],
    '👨‍💼': ['man_office_worker', 'businesswoman'],
    '👩‍💼': ['woman_office_worker', 'businesswoman'],
    '👨‍🔬': ['man_scientist'],
    '👩‍🔬': ['woman_scientist'],
    '👨‍💻': ['man_technologist', 'man_blogger'],
    '👩‍💻': ['woman_technologist', 'woman_blogger'],
    '👨‍🎤': ['man_singer'],
    '👩‍🎤': ['woman_singer'],
    '👨‍🎨': ['man_artist'],
    '👩‍🎨': ['woman_artist'],
    '👨‍✈️': ['man_pilot'],
    '👩‍✈️': ['woman_pilot'],
    '👨‍🚀': ['man_astronaut'],
    '👩‍🚀': ['woman_astronaut'],
    '👨‍🚒': ['man_firefighter'],
    '👩‍🚒': ['woman_firefighter'],
    '👮‍♂️': ['policeman'],
    '👮‍♀️': ['policewoman'],
    '🕵️‍♂️': ['man_detective', 'man_spy', 'man_sleuth'],
    '🕵️‍♀️': ['woman_detective', 'woman_spy', 'woman_sleuth'],
    '💂‍♂️': ['guardsman', 'man_guard'],
    '💂‍♀️': ['guardswoman', 'woman_guard'],
    '👷‍♂️': ['man_construction_worker'],
    '👷‍♀️': ['woman_construction_worker'],
    '👳‍♂️': ['man_with_turban'],
    '👳‍♀️': ['woman_with_turban'],
    '👱‍♂️': ['man_with_blond_hair'],
    '👱‍♀️': ['woman_with_blond_hair'],
    '🙍‍♂️': ['man_frowning'],
    '🙍‍♀️': ['woman_frowning'],
    '🙎‍♂️': ['man_pouting'],
    '🙎‍♀️': ['woman_pouting'],
    '🙅‍♂️': ['man_no'],
    '🙅‍♀️': ['woman_no'],
    '🙆‍♂️': ['man_ok', 'ok_man'],
    '🙆‍♀️': ['woman_ok', 'ok_woman'],
    '💁‍♂️': ['man_tipping_hand', 'information_desk_man'],
    '💁‍♀️': ['woman_tipping_hand', 'information_desk_woman'],
    '🙋‍♂️': ['man_raising_hand'],
    '🙋‍♀️': ['woman_raising_hand'],
    '🙇‍♂️': ['man_bowing'],
    '🙇‍♀️': ['woman_bowing'],
    '🤦‍♂️': ['man_facepalming', 'man_face_palm'],
    '🤦‍♀️': ['woman_facepalming', 'woman_face_palm'],
    '🤷‍♂️': ['man_shrug'],
    '🤷‍♀️': ['woman_shrug']
  },
  nature: {
    '🐶': ['dog'],
    '🐱': ['cat'],
    '🐭': ['mouse'],
    '🐹': ['hamster'],
    '🐰': ['rabbit'],
    '🐻': ['bear'],
    '🐼': ['panda_face'],
    '🐨': ['koala'],
    '🐯': ['tiger'],
    '🦁': ['lion_face', 'lion'],
    '🐮': ['cow'],
    '🐷': ['pig'],
    '🐽': ['pig_nose'],
    '🐸': ['frog'],
    '🐙': ['octopus'],
    '🐵': ['monkey_face'],
    '🙈': ['see_no_evil'],
    '🙉': ['hear_no_evil'],
    '🙊': ['speak_no_evil'],
    '🐒': ['monkey'],
    '🐔': ['chicken'],
    '🐧': ['penguin'],
    '🐦': ['bird'],
    '🐤': ['baby_chick'],
    '🐣': ['hatching_chick'],
    '🐥': ['hatched_chick'],
    '🐺': ['wolf'],
    '🐗': ['boar'],
    '🐴': ['horse'],
    '🦄': ['unicorn', 'unicorn_face'],
    '🐝': ['bee'],
    '🐛': ['bug'],
    '🐌': ['snail'],
    '🐞': ['beetle'],
    '🐜': ['ant'],
    '🕷': ['spider'],
    '🦂': ['scorpion'],
    '🦀': ['crab'],
    '🐍': ['snake'],
    '🐢': ['turtle'],
    '🐠': ['tropical_fish'],
    '🐟': ['fish'],
    '🐡': ['blowfish'],
    '🐬': ['dolphin'],
    '🐳': ['whale'],
    '🐋': ['whale2'],
    '🐊': ['crocodile'],
    '🐆': ['leopard'],
    '🐅': ['tiger2'],
    '🐃': ['water_buffalo'],
    '🐂': ['ox'],
    '🐄': ['cow2'],
    '🐪': ['dromedary_camel'],
    '🐫': ['camel'],
    '🐘': ['elephant'],
    '🐐': ['goat'],
    '🐏': ['ram'],
    '🐑': ['sheep'],
    '🐎': ['racehorse'],
    '🐖': ['pig2'],
    '🐀': ['rat'],
    '🐁': ['mouse2'],
    '🐓': ['rooster'],
    '🦃': ['turkey'],
    '🕊': ['dove', 'dove_of_peace'],
    '🐕': ['dog2'],
    '🐩': ['poodle'],
    '🐈': ['cat2'],
    '🐇': ['rabbit2'],
    '🐿': ['chipmunk'],
    '🐾': ['feet', 'paw_prints'],
    '🐉': ['dragon'],
    '🐲': ['dragon_face'],
    '🌵': ['cactus'],
    '🎄': ['christmas_tree'],
    '🌲': ['evergreen_tree'],
    '🌳': ['deciduous_tree'],
    '🌴': ['palm_tree'],
    '🌱': ['seedling'],
    '🌿': ['herb'],
    '☘': ['shamrock'],
    '🍀': ['four_leaf_clover'],
    '🎍': ['bamboo'],
    '🎋': ['tanabata_tree'],
    '🍃': ['leaves'],
    '🍂': ['fallen_leaf'],
    '🍁': ['maple_leaf'],
    '🌾': ['ear_of_rice'],
    '🌺': ['hibiscus'],
    '🌻': ['sunflower'],
    '🌹': ['rose'],
    '🌷': ['tulip'],
    '🌼': ['blossom'],
    '🌸': ['cherry_blossom'],
    '💐': ['bouquet'],
    '🍄': ['mushroom'],
    '🌰': ['chestnut'],
    '🎃': ['jack_o_lantern'],
    '🐚': ['shell'],
    '🕸': ['spider_web'],
    '🌎': ['earth_americas'],
    '🌍': ['earth_africa'],
    '🌏': ['earth_asia'],
    '🌕': ['full_moon'],
    '🌖': ['waning_gibbous_moon'],
    '🌗': ['last_quarter_moon'],
    '🌘': ['waning_crescent_moon'],
    '🌑': ['new_moon'],
    '🌒': ['waxing_crescent_moon'],
    '🌓': ['first_quarter_moon'],
    '🌔': ['waxing_gibbous_moon'],
    '🌚': ['new_moon_with_face'],
    '🌝': ['full_moon_with_face'],
    '🌛': ['first_quarter_moon_with_face'],
    '🌜': ['last_quarter_moon_with_face'],
    '🌞': ['sun_with_face'],
    '🌙': ['crescent_moon'],
    '⭐': ['star'],
    '🌟': ['star2'],
    '💫': ['dizzy'],
    '✨': ['sparkles'],
    '☄': ['comet'],
    '☀': ['sunny'],
    '🌤': ['white_sun_small_cloud', 'white_sun_with_small_cloud'],
    '⛅': ['partly_sunny'],
    '🌥': ['white_sun_cloud', 'white_sun_behind_cloud'],
    '🌦': ['white_sun_rain_cloud', 'white_sun_behind_cloud_with_rain'],
    '☁': ['cloud'],
    '🌧': ['cloud_rain', 'cloud_with_rain'],
    '⛈': ['thunder_cloud_rain', 'thunder_cloud_and_rain'],
    '🌩': ['cloud_lightning', 'cloud_with_lightning'],
    '⚡': ['zap'],
    '🔥': ['fire', 'flame'],
    '💥': ['boom'],
    '❄': ['snowflake'],
    '🌨': ['cloud_snow', 'cloud_with_snow'],
    '☃': ['snowman2'],
    '⛄': ['snowman'],
    '🌬': ['wind_blowing_face'],
    '💨': ['dash'],
    '🌪': ['cloud_tornado', 'cloud_with_tornado'],
    '🌫': ['fog'],
    '☂': ['umbrella2'],
    '☔': ['umbrella'],
    '💧': ['droplet'],
    '💦': ['sweat_drops'],
    '🌊': ['ocean'],
    '🦅': ['eagle'],
    '🦆': ['duck'],
    '🦇': ['bat'],
    '🦈': ['shark'],
    '🦉': ['owl'],
    '🦊': ['fox', 'fox_face'],
    '🦋': ['butterfly'],
    '🦌': ['deer'],
    '🦍': ['gorilla'],
    '🦎': ['lizard'],
    '🦏': ['rhino', 'rhinoceros'],
    '🥀': ['wilted_rose', 'wilted_flower'],
    '🦐': ['shrimp'],
    '🦑': ['squid'],
    '🦝': ['raccoon'],
    '🦙': ['llama', 'alpaca', 'wool'],
    '🦛': ['hippopotamus', 'hippo'],
    '🦘': ['kangaroo', 'australia', 'jump', 'marsupial'],
    '🦡': ['badger', 'honey_badger'],
    '🦢': ['swan', 'cygnet'],
    '🦚': ['peacock', 'peahen'],
    '🦜': ['parrot'],
    '🦞': ['lobster', 'bisque', 'seafood'],
    '🦟': ['mosquito', 'insect', 'disease', 'malaria', 'fever'],
    '🦠': ['microbe', 'amoeba', 'bacteria', 'virus'],
    '🦓': ['zebra'],
    '🦒': ['giraffe'],
    '🦔': ['hedgehog', 'echinda', 'spiny'],
    '🦕': [
      'sauropod',
      'brachiosaurus',
      'brontosaurus',
      'diplodocus',
      'dinosaur'
    ],
    '🦖': ['t_rex', 'tyrannosaurus_rex'],
    '🦗': ['cricket', 'grasshopper', 'orthoptera']
  },
  food: {
    '🍏': ['green_apple'],
    '🍎': ['apple'],
    '🍐': ['pear'],
    '🍊': ['tangerine'],
    '🍋': ['lemon'],
    '🍌': ['banana'],
    '🍉': ['watermelon'],
    '🍇': ['grapes'],
    '🍓': ['strawberry'],
    '🍈': ['melon'],
    '🍒': ['cherries'],
    '🍑': ['peach'],
    '🍍': ['pineapple'],
    '🍅': ['tomato'],
    '🍆': ['eggplant'],
    '🌶': ['hot_pepper'],
    '🌽': ['corn'],
    '🍠': ['sweet_potato'],
    '🍯': ['honey_pot'],
    '🍞': ['bread'],
    '🧀': ['cheese', 'cheese_wedge'],
    '🍗': ['poultry_leg'],
    '🍖': ['meat_on_bone'],
    '🍤': ['fried_shrimp'],
    '🍳': ['cooking'],
    '🍔': ['hamburger'],
    '🍟': ['fries'],
    '🌭': ['hotdog', 'hot_dog'],
    '🍕': ['pizza'],
    '🍝': ['spaghetti'],
    '🌮': ['taco'],
    '🌯': ['burrito'],
    '🍜': ['ramen'],
    '🍲': ['stew'],
    '🍥': ['fish_cake'],
    '🍣': ['sushi'],
    '🍱': ['bento'],
    '🍛': ['curry'],
    '🍙': ['rice_ball'],
    '🍚': ['rice'],
    '🍘': ['rice_cracker'],
    '🍢': ['oden'],
    '🍡': ['dango'],
    '🍧': ['shaved_ice'],
    '🍨': ['ice_cream'],
    '🍦': ['icecream'],
    '🍰': ['cake'],
    '🎂': ['birthday'],
    '🍮': ['custard', 'pudding', 'flan'],
    '🍬': ['candy'],
    '🍭': ['lollipop'],
    '🍫': ['chocolate_bar'],
    '🍿': ['popcorn'],
    '🍩': ['doughnut'],
    '🍪': ['cookie'],
    '🍺': ['beer'],
    '🍻': ['beers'],
    '🍷': ['wine_glass'],
    '🍸': ['cocktail'],
    '🍹': ['tropical_drink'],
    '🍾': ['champagne', 'bottle_with_popping_cork'],
    '🍶': ['sake'],
    '🍵': ['tea'],
    '☕': ['coffee'],
    '🍼': ['baby_bottle'],
    '🍴': ['fork_and_knife'],
    '🍽': ['fork_knife_plate', 'fork_and_knife_with_plate'],
    '🥐': ['croissant'],
    '🥑': ['avocado'],
    '🥒': ['cucumber'],
    '🥓': ['bacon'],
    '🥔': ['potato'],
    '🥕': ['carrot'],
    '🥖': ['french_bread', 'baguette_bread'],
    '🥗': ['salad', 'green_salad'],
    '🥘': ['shallow_pan_of_food', 'paella'],
    '🥙': ['stuffed_flatbread', 'stuffed_pita'],
    '🥂': ['champagne_glass', 'clinking_glass'],
    '🥃': ['tumbler_glass', 'whisky'],
    '🥄': ['spoon'],
    '🥚': ['egg'],
    '🥛': ['milk', 'glass_of_milk'],
    '🥜': ['peanuts', 'shelled_peanut'],
    '🥝': ['kiwi', 'kiwifruit'],
    '🥞': ['pancakes'],
    '🥭': ['mango', 'tropical'],
    '🥬': ['leafy_green', 'cabbage', 'kale', 'lettuce'],
    '🥯': ['bagel', 'schmear'],
    '🧂': ['salt', 'condement', 'shaker', 'salt_shaker'],
    '🥮': ['moon_cake'],
    '🧁': ['cupcake', 'bakery', 'sweet'],
    '🥥': ['coconut'],
    '🥦': ['broccoli'],
    '🥨': ['pretzel'],
    '🥩': ['cut_of_meat', 'steak', 'lambchop', 'porkchop'],
    '🥪': ['sandwich'],
    '🥣': ['bowl_with_spoon', 'cereal_bowl', 'oatmeal'],
    '🥫': ['canned_food', 'can'],
    '🥟': ['dumpling', 'potsticker'],
    '🥠': ['fortune_cookie'],
    '🥡': ['takeout_box'],
    '🥧': ['pie'],
    '🥤': ['cup_with_straw', 'to_go_cup'],
    '🥢': ['chopsticks']
  },
  activity: {
    '⚽': ['soccer'],
    '🏀': ['basketball'],
    '🏈': ['football'],
    '⚾': ['baseball'],
    '🎾': ['tennis'],
    '🏐': ['volleyball'],
    '🏉': ['rugby_football'],
    '🎱': ['8ball'],
    '⛳': ['golf'],
    '🏌': ['golfer'],
    '🏓': ['ping_pong', 'table_tennis'],
    '🏸': ['badminton'],
    '🏒': ['hockey'],
    '🏑': ['field_hockey'],
    '🏏': ['cricket', 'cricket_bat_ball'],
    '🎿': ['ski'],
    '⛷': ['skier'],
    '🏂': ['snowboarder'],
    '⛸': ['ice_skate'],
    '🏹': ['bow_and_arrow', 'archery'],
    '🎣': ['fishing_pole_and_fish'],
    '🚣': ['rowboat'],
    '🏊': ['swimmer'],
    '🏄': ['surfer'],
    '🛀': ['bath'],
    '⛹': ['basketball_player', 'person_with_ball'],
    '🏋': ['lifter', 'weight_lifter'],
    '🚴': ['bicyclist'],
    '🚵': ['mountain_bicyclist'],
    '🏇': ['horse_racing'],
    '🕴': ['levitate', 'man_in_business_suit_levitating'],
    '🏆': ['trophy'],
    '🎽': ['running_shirt_with_sash'],
    '🏅': ['medal', 'sports_medal'],
    '🎖': ['military_medal'],
    '🎗': ['reminder_ribbon'],
    '🏵': ['rosette'],
    '🎫': ['ticket'],
    '🎟': ['tickets', 'admission_tickets'],
    '🎭': ['performing_arts'],
    '🎨': ['art'],
    '🎪': ['circus_tent'],
    '🎤': ['microphone'],
    '🎧': ['headphones'],
    '🎼': ['musical_score'],
    '🎹': ['musical_keyboard'],
    '🎷': ['saxophone'],
    '🎺': ['trumpet'],
    '🎸': ['guitar'],
    '🎻': ['violin'],
    '🎬': ['clapper'],
    '🎮': ['video_game'],
    '👾': ['space_invader'],
    '🎯': ['dart'],
    '🎲': ['game_die'],
    '🎰': ['slot_machine'],
    '🎳': ['bowling'],
    '🤸': ['cartwheel', 'person_doing_cartwheel'],
    '🤹': ['juggling', 'juggler'],
    '🤼': ['wrestlers', 'wrestling'],
    '🥊': ['boxing_glove', 'boxing_gloves'],
    '🥋': ['martial_arts_uniform', 'karate_uniform'],
    '🤽': ['water_polo'],
    '🤾': ['handball'],
    '🥅': ['goal', 'goal_net'],
    '🤺': ['fencer', 'fencing'],
    '🥇': ['first_place', 'first_place_medal'],
    '🥈': ['second_place', 'second_place_medal'],
    '🥉': ['third_place', 'third_place_medal'],
    '🥁': ['drum', 'drum_with_drumsticks'],
    '🥌': ['curling_stone'],
    '🛷': ['sled', 'sledge', 'sleigh', 'luge', 'toboggan'],
    '🧨': ['firecracker', 'dynamite', 'explosive', 'fireworks'],
    '🧧': ['red_envelope', 'red_gift_envelope', 'lai_see', 'red_packet'],
    '🥎': ['softball'],
    '🥏': ['flying_disc', 'frisbee', 'ultimate'],
    '🥍': ['lacrosse'],
    '🧿': ['nazar_amulet'],
    '🧩': ['jigsaw', 'puzzle'],
    '🧸': ['teddy_bear', 'toy'],
    '♟️': ['chess_pawn', 'chess'],
    '🧵': ['thread', 'spool', 'string'],
    '🧶': ['yarn', 'crochet', 'knit'],
    '💆‍♂️': ['man_massage'],
    '💆‍♀️': ['woman_massage'],
    '💇‍♂️': ['man_haircut'],
    '💇‍♀️': ['woman_haircut'],
    '🚶‍♂️': ['man_walking', 'man_pedestrian'],
    '🚶‍♀️': ['woman_walking', 'woman_pedestrian'],
    '🏃‍♂️': ['man_running', 'man_runner'],
    '🏃‍♀️': ['woman_running', 'woman_runner'],
    '👯‍♂️': ['men_with_bunny_ears_partying', 'men_dancing'],
    '👯‍♀️': ['women_with_bunny_ears_partying', 'women_dancing'],
    '🏌️‍♂️': ['man_golfing', 'man_golfer'],
    '🏌️‍♀️': ['woman_golfing', 'woman_golfer'],
    '🏄‍♂️': ['man_surfing', 'man_surfer'],
    '🏄‍♀️': ['woman_surfing', 'woman_surfer'],
    '🚣‍♂️': ['man_rowing_boat', 'man_rowboat'],
    '🚣‍♀️': ['woman_rowing_boat', 'woman_rowboat'],
    '🏊‍♂️': ['man_swimming', 'man_swimmer'],
    '🏊‍♀️': ['woman_swimming', 'woman_swimmer'],
    '⛹️‍♂️': ['man_bouncing_ball', 'man_basketball_player'],
    '⛹️‍♀️': ['woman_bouncing_ball', 'woman_bouncing_ball'],
    '🏋️‍♂️': ['man_lifting_weights', 'man_weight_lifter'],
    '🏋️‍♀️': ['woman_lifting_weights', 'woman_weight_lifter'],
    '🚴‍♂️': ['man_biking', 'man_bicyclist'],
    '🚴‍♀️': ['woman_biking', 'woman_bicyclist'],
    '🚵‍♂️': ['man_mountain_biking', 'man_mountain_bicyclist'],
    '🚵‍♀️': ['woman_mountain_biking', 'woman_mountain_bicyclist'],
    '🤸‍♂️': ['man_cartwheeling', 'man_doing_cartwheel'],
    '🤸‍♀️': ['woman_cartwheeling', 'woman_doing_cartwheel'],
    '🤼‍♂️': ['men_wrestling', 'men_wrestlers'],
    '🤼‍♀️': ['women_wrestling', 'women_wrestlers'],
    '🤽‍♂️': ['man_playing_water_polo'],
    '🤽‍♀️': ['woman_playing_water_polo'],
    '🤾‍♂️': ['man_playing_handball'],
    '🤾‍♀️': ['woman_playing_handball'],
    '🤹‍♂️': ['man_juggling', 'man_juggler'],
    '🤹‍♀️': ['woman_juggling', 'woman_juggler']
  },
  travel: {
    '🚗': ['red_car'],
    '🚕': ['taxi'],
    '🚙': ['blue_car'],
    '🚌': ['bus'],
    '🚎': ['trolleybus'],
    '🏎': ['race_car', 'racing_car'],
    '🚓': ['police_car'],
    '🚑': ['ambulance'],
    '🚒': ['fire_engine'],
    '🚐': ['minibus'],
    '🚚': ['truck'],
    '🚛': ['articulated_lorry'],
    '🚜': ['tractor'],
    '🏍': ['motorcycle', 'racing_motorcycle'],
    '🚲': ['bike'],
    '🚨': ['rotating_light'],
    '🚔': ['oncoming_police_car'],
    '🚍': ['oncoming_bus'],
    '🚘': ['oncoming_automobile'],
    '🚖': ['oncoming_taxi'],
    '🚡': ['aerial_tramway'],
    '🚠': ['mountain_cableway'],
    '🚟': ['suspension_railway'],
    '🚃': ['railway_car'],
    '🚋': ['train'],
    '🚝': ['monorail'],
    '🚄': ['bullettrain_side'],
    '🚅': ['bullettrain_front'],
    '🚈': ['light_rail'],
    '🚞': ['mountain_railway'],
    '🚂': ['steam_locomotive'],
    '🚆': ['train2'],
    '🚇': ['metro'],
    '🚊': ['tram'],
    '🚉': ['station'],
    '🚁': ['helicopter'],
    '🛩': ['airplane_small', 'small_airplane'],
    '✈': ['airplane'],
    '🛫': ['airplane_departure'],
    '🛬': ['airplane_arriving'],
    '⛵': ['sailboat'],
    '🛥': ['motorboat'],
    '🚤': ['speedboat'],
    '⛴': ['ferry'],
    '🛳': ['cruise_ship', 'passenger_ship'],
    '🚀': ['rocket'],
    '🛰': ['satellite_orbital'],
    '💺': ['seat'],
    '⚓': ['anchor'],
    '🚧': ['construction'],
    '⛽': ['fuelpump'],
    '🚏': ['busstop'],
    '🚦': ['vertical_traffic_light'],
    '🚥': ['traffic_light'],
    '🏁': ['checkered_flag'],
    '🚢': ['ship'],
    '🎡': ['ferris_wheel'],
    '🎢': ['roller_coaster'],
    '🎠': ['carousel_horse'],
    '🏗': ['construction_site', 'building_construction'],
    '🌁': ['foggy'],
    '🗼': ['tokyo_tower'],
    '🏭': ['factory'],
    '⛲': ['fountain'],
    '🎑': ['rice_scene'],
    '⛰': ['mountain'],
    '🏔': ['mountain_snow', 'snow_capped_mountain'],
    '🗻': ['mount_fuji'],
    '🌋': ['volcano'],
    '🗾': ['japan'],
    '🏕': ['camping'],
    '⛺': ['tent'],
    '🏞': ['park', 'national_park'],
    '🛣': ['motorway'],
    '🛤': ['railway_track', 'railroad_track'],
    '🌅': ['sunrise'],
    '🌄': ['sunrise_over_mountains'],
    '🏜': ['desert'],
    '🏖': ['beach', 'beach_with_umbrella'],
    '🏝': ['island', 'desert_island'],
    '🌇': ['city_sunset', 'city_sunrise'],
    '🌆': ['city_dusk'],
    '🏙': ['cityscape'],
    '🌃': ['night_with_stars'],
    '🌉': ['bridge_at_night'],
    '🌌': ['milky_way'],
    '🌠': ['stars'],
    '🎇': ['sparkler'],
    '🎆': ['fireworks'],
    '🌈': ['rainbow'],
    '🏘': ['homes', 'house_buildings'],
    '🏰': ['european_castle'],
    '🏯': ['japanese_castle'],
    '🏟': ['stadium'],
    '🗽': ['statue_of_liberty'],
    '🏠': ['house'],
    '🏡': ['house_with_garden'],
    '🏚': ['house_abandoned', 'derelict_house_building'],
    '🏢': ['office'],
    '🏬': ['department_store'],
    '🏣': ['post_office'],
    '🏤': ['european_post_office'],
    '🏥': ['hospital'],
    '🏦': ['bank'],
    '🏨': ['hotel'],
    '🏪': ['convenience_store'],
    '🏫': ['school'],
    '🏩': ['love_hotel'],
    '💒': ['wedding'],
    '🏛': ['classical_building'],
    '⛪': ['church'],
    '🕌': ['mosque'],
    '🕍': ['synagogue'],
    '🕋': ['kaaba'],
    '⛩': ['shinto_shrine'],
    '🛴': ['scooter'],
    '🛵': ['motor_scooter', 'motorbike'],
    '🛶': ['canoe', 'kayak'],
    '🛸': ['flying_saucer', 'ufo'],
    '🧭': ['compass', 'navigation', 'orienteering'],
    '🧱': ['brick'],
    '🛹': ['skateboard'],
    '🧳': ['luggage', 'packing', 'travel']
  },
  objects: {
    '⌚': ['watch'],
    '📱': ['iphone'],
    '📲': ['calling'],
    '💻': ['computer'],
    '⌨': ['keyboard'],
    '🖥': ['desktop', 'desktop_computer'],
    '🖨': ['printer'],
    '🖱': ['mouse_three_button', 'three_button_mouse'],
    '🖲': ['trackball'],
    '🕹': ['joystick'],
    '🗜': ['compression'],
    '💽': ['minidisc'],
    '💾': ['floppy_disk'],
    '💿': ['cd'],
    '📀': ['dvd'],
    '📼': ['vhs'],
    '📷': ['camera'],
    '📸': ['camera_with_flash'],
    '📹': ['video_camera'],
    '🎥': ['movie_camera'],
    '📽': ['projector', 'film_projector'],
    '🎞': ['film_frames'],
    '📞': ['telephone_receiver'],
    '☎': ['telephone'],
    '📟': ['pager'],
    '📠': ['fax'],
    '📺': ['tv'],
    '📻': ['radio'],
    '🎙': ['microphone2', 'studio_microphone'],
    '🎚': ['level_slider'],
    '🎛': ['control_knobs'],
    '⏱': ['stopwatch'],
    '⏲': ['timer', 'timer_clock'],
    '⏰': ['alarm_clock'],
    '🕰': ['clock', 'mantlepiece_clock'],
    '⏳': ['hourglass_flowing_sand'],
    '⌛': ['hourglass'],
    '📡': ['satellite'],
    '🔋': ['battery'],
    '🔌': ['electric_plug'],
    '💡': ['bulb'],
    '🔦': ['flashlight'],
    '🕯': ['candle'],
    '🗑': ['wastebasket'],
    '🛢': ['oil', 'oil_drum'],
    '💸': ['money_with_wings'],
    '💵': ['dollar'],
    '💴': ['yen'],
    '💶': ['euro'],
    '💷': ['pound'],
    '💰': ['moneybag'],
    '💳': ['credit_card'],
    '💎': ['gem'],
    '⚖': ['scales'],
    '🔧': ['wrench'],
    '🔨': ['hammer'],
    '⚒': ['hammer_pick', 'hammer_and_pick'],
    '🛠': ['tools', 'hammer_and_wrench'],
    '⛏': ['pick'],
    '🔩': ['nut_and_bolt'],
    '⚙': ['gear'],
    '⛓': ['chains'],
    '🔫': ['gun'],
    '💣': ['bomb'],
    '🔪': ['knife'],
    '🗡': ['dagger', 'dagger_knife'],
    '⚔': ['crossed_swords'],
    '🛡': ['shield'],
    '🚬': ['smoking'],
    '☠': ['skull_crossbones', 'skull_and_crossbones'],
    '⚰': ['coffin'],
    '⚱': ['urn', 'funeral_urn'],
    '🏺': ['amphora'],
    '🔮': ['crystal_ball'],
    '📿': ['prayer_beads'],
    '💈': ['barber'],
    '⚗': ['alembic'],
    '🔭': ['telescope'],
    '🔬': ['microscope'],
    '🕳': ['hole'],
    '💊': ['pill'],
    '💉': ['syringe'],
    '🌡': ['thermometer'],
    '🏷': ['label'],
    '🔖': ['bookmark'],
    '🚽': ['toilet'],
    '🚿': ['shower'],
    '🛁': ['bathtub'],
    '🔑': ['key'],
    '🗝': ['key2', 'old_key'],
    '🛋': ['couch', 'couch_and_lamp'],
    '🛌': ['sleeping_accommodation', 'person_sleeping'],
    '🛏': ['bed'],
    '🚪': ['door'],
    '🛎': ['bellhop', 'bellhop_bell'],
    '🖼': ['frame_photo', 'frame_with_picture'],
    '🗺': ['map', 'world_map'],
    '⛱': ['beach_umbrella', 'umbrella_on_ground'],
    '🗿': ['moyai'],
    '🛍': ['shopping_bags'],
    '🎈': ['balloon'],
    '🎏': ['flags'],
    '🎀': ['ribbon'],
    '🎁': ['gift'],
    '🎊': ['confetti_ball'],
    '🎉': ['tada'],
    '🎎': ['dolls'],
    '🎐': ['wind_chime'],
    '🎌': ['crossed_flags'],
    '🏮': ['izakaya_lantern'],
    '✉': ['envelope'],
    '📩': ['envelope_with_arrow'],
    '📨': ['incoming_envelope'],
    '📧': ['e_mail', 'email'],
    '💌': ['love_letter'],
    '📮': ['postbox'],
    '📪': ['mailbox_closed'],
    '📫': ['mailbox'],
    '📬': ['mailbox_with_mail'],
    '📭': ['mailbox_with_no_mail'],
    '📦': ['package'],
    '📯': ['postal_horn'],
    '📥': ['inbox_tray'],
    '📤': ['outbox_tray'],
    '📜': ['scroll'],
    '📃': ['page_with_curl'],
    '📑': ['bookmark_tabs'],
    '📊': ['bar_chart'],
    '📈': ['chart_with_upwards_trend'],
    '📉': ['chart_with_downwards_trend'],
    '📄': ['page_facing_up'],
    '📅': ['date'],
    '📆': ['calendar'],
    '🗓': ['calendar_spiral', 'spiral_calendar_pad'],
    '📇': ['card_index'],
    '🗃': ['card_box', 'card_file_box'],
    '🗳': ['ballot_box', 'ballot_box_with_ballot'],
    '🗄': ['file_cabinet'],
    '📋': ['clipboard'],
    '🗒': ['notepad_spiral', 'spiral_note_pad'],
    '📁': ['file_folder'],
    '📂': ['open_file_folder'],
    '🗂': ['dividers', 'card_index_dividers'],
    '🗞': ['newspaper2', 'rolled_up_newspaper'],
    '📰': ['newspaper'],
    '📓': ['notebook'],
    '📕': ['closed_book'],
    '📗': ['green_book'],
    '📘': ['blue_book'],
    '📙': ['orange_book'],
    '📔': ['notebook_with_decorative_cover'],
    '📒': ['ledger'],
    '📚': ['books'],
    '📖': ['book'],
    '🔗': ['link'],
    '📎': ['paperclip'],
    '🖇': ['paperclips', 'linked_paperclips'],
    '✂': ['scissors'],
    '📐': ['triangular_ruler'],
    '📏': ['straight_ruler'],
    '📌': ['pushpin'],
    '📍': ['round_pushpin'],
    '🚩': ['triangular_flag_on_post'],
    '🏳': ['flag_white'],
    '🏴': ['flag_black'],
    '🔐': ['closed_lock_with_key'],
    '🔒': ['lock'],
    '🔓': ['unlock'],
    '🔏': ['lock_with_ink_pen'],
    '🖊': ['pen_ballpoint', 'lower_left_ballpoint_pen'],
    '🖋': ['pen_fountain', 'lower_left_fountain_pen'],
    '✒': ['black_nib'],
    '📝': ['pencil'],
    '✏': ['pencil2'],
    '🖍': ['crayon', 'lower_left_crayon'],
    '🖌': ['paintbrush', 'lower_left_paintbrush'],
    '🔍': ['mag'],
    '🔎': ['mag_right'],
    '🛒': ['shopping_cart', 'shopping_trolley'],
    '🧮': ['abacus', 'calculation'],
    '🧾': ['receipt'],
    '🧰': ['toolbox', 'mechanic'],
    '🧲': ['magnet', 'horseshoe'],
    '🧪': ['test_tube', 'chemistry', 'experiment', 'science'],
    '🧫': ['petri_dish', 'biologist', 'biology', 'lab'],
    '🧬': ['dna', 'evolution', 'gene', 'genetics'],
    '🧴': ['lotion', 'moisturizer', 'shampoo', 'sunscreen'],
    '🧷': ['safety_pin'],
    '🧹': ['broom', 'clean', 'sweep'],
    '🧺': ['basket'],
    '🧻': ['toilet_paper', 'roll_of_paper', 'bathroom_tissue'],
    '🧼': ['soap'],
    '🧽': ['sponge'],
    '🧯': ['fire_extinguisher']
  },
  symbols: {
    '💯': ['100'],
    '🔢': ['1234'],
    '❤': ['heart'],
    '💛': ['yellow_heart'],
    '💚': ['green_heart'],
    '💙': ['blue_heart'],
    '💜': ['purple_heart'],
    '💔': ['broken_heart'],
    '❣': ['heart_exclamation', 'heavy_heart_exclamation_mark_ornament'],
    '💕': ['two_hearts'],
    '💞': ['revolving_hearts'],
    '💓': ['heartbeat'],
    '💗': ['heartpulse'],
    '💖': ['sparkling_heart'],
    '💘': ['cupid'],
    '💝': ['gift_heart'],
    '💟': ['heart_decoration'],
    '☮': ['peace', 'peace_symbol'],
    '✝': ['cross', 'latin_cross'],
    '☪': ['star_and_crescent'],
    '🕉': ['om_symbol'],
    '☸': ['wheel_of_dharma'],
    '✡': ['star_of_david'],
    '🔯': ['six_pointed_star'],
    '🕎': ['menorah'],
    '☯': ['yin_yang'],
    '☦': ['orthodox_cross'],
    '🛐': ['place_of_worship', 'worship_symbol'],
    '⛎': ['ophiuchus'],
    '♈': ['aries'],
    '♉': ['taurus'],
    '♊': ['gemini'],
    '♋': ['cancer'],
    '♌': ['leo'],
    '♍': ['virgo'],
    '♎': ['libra'],
    '♏': ['scorpius'],
    '♐': ['sagittarius'],
    '♑': ['capricorn'],
    '♒': ['aquarius'],
    '♓': ['pisces'],
    '🆔': ['id'],
    '⚛': ['atom', 'atom_symbol'],
    '🈳': ['u7a7a'],
    '🈹': ['u5272'],
    '☢': ['radioactive', 'radioactive_sign'],
    '☣': ['biohazard', 'biohazard_sign'],
    '📴': ['mobile_phone_off'],
    '📳': ['vibration_mode'],
    '🈶': ['u6709'],
    '🈚': ['u7121'],
    '🈸': ['u7533'],
    '🈺': ['u55b6'],
    '🈷': ['u6708'],
    '✴': ['eight_pointed_black_star'],
    '🆚': ['vs'],
    '🉑': ['accept'],
    '💮': ['white_flower'],
    '🉐': ['ideograph_advantage'],
    '㊙': ['secret'],
    '㊗': ['congratulations'],
    '🈴': ['u5408'],
    '🈵': ['u6e80'],
    '🈲': ['u7981'],
    '🅰': ['a'],
    '🅱': ['b'],
    '🆎': ['ab'],
    '🆑': ['cl'],
    '🅾': ['o2'],
    '🆘': ['sos'],
    '⛔': ['no_entry'],
    '📛': ['name_badge'],
    '🚫': ['no_entry_sign'],
    '❌': ['x'],
    '⭕': ['o'],
    '💢': ['anger'],
    '♨': ['hotsprings'],
    '🚷': ['no_pedestrians'],
    '🚯': ['do_not_litter'],
    '🚳': ['no_bicycles'],
    '🚱': ['non_potable_water'],
    '🔞': ['underage'],
    '📵': ['no_mobile_phones'],
    '❗': ['exclamation'],
    '❕': ['grey_exclamation'],
    '❓': ['question'],
    '❔': ['grey_question'],
    '‼': ['bangbang'],
    '⁉': ['interrobang'],
    '🔅': ['low_brightness'],
    '🔆': ['high_brightness'],
    '🔱': ['trident'],
    '⚜': ['fleur_de_lis'],
    '〽': ['part_alternation_mark'],
    '⚠': ['warning'],
    '🚸': ['children_crossing'],
    '🔰': ['beginner'],
    '♻': ['recycle'],
    '🈯': ['u6307'],
    '💹': ['chart'],
    '❇': ['sparkle'],
    '✳': ['eight_spoked_asterisk'],
    '❎': ['negative_squared_cross_mark'],
    '✅': ['white_check_mark'],
    '💠': ['diamond_shape_with_a_dot_inside'],
    '🌀': ['cyclone'],
    '➿': ['loop'],
    '🌐': ['globe_with_meridians'],
    'Ⓜ': ['m'],
    '🏧': ['atm'],
    '🈂': ['sa'],
    '🛂': ['passport_control'],
    '🛃': ['customs'],
    '🛄': ['baggage_claim'],
    '🛅': ['left_luggage'],
    '♿': ['wheelchair'],
    '🚭': ['no_smoking'],
    '🚾': ['wc'],
    '🅿': ['parking'],
    '🚰': ['potable_water'],
    '🚹': ['mens'],
    '🚺': ['womens'],
    '🚼': ['baby_symbol'],
    '🚻': ['restroom'],
    '🚮': ['put_litter_in_its_place'],
    '🎦': ['cinema'],
    '📶': ['signal_strength'],
    '🈁': ['koko'],
    '🆖': ['ng'],
    '🆗': ['ok'],
    '🆙': ['up'],
    '🆒': ['cool'],
    '🆕': ['new'],
    '🆓': ['free'],
    '0⃣': ['zero'],
    '1⃣': ['one'],
    '2⃣': ['two'],
    '3⃣': ['three'],
    '4⃣': ['four'],
    '5⃣': ['five'],
    '6⃣': ['six'],
    '7⃣': ['seven'],
    '8⃣': ['eight'],
    '9⃣': ['nine'],
    '🔟': ['keycap_ten'],
    '▶': ['arrow_forward'],
    '⏸': ['pause_button', 'double_vertical_bar'],
    '⏯': ['play_pause'],
    '⏹': ['stop_button'],
    '⏺': ['record_button'],
    '⏭': ['track_next', 'next_track'],
    '⏮': ['track_previous', 'previous_track'],
    '⏩': ['fast_forward'],
    '⏪': ['rewind'],
    '🔀': ['twisted_rightwards_arrows'],
    '🔁': ['repeat'],
    '🔂': ['repeat_one'],
    '◀': ['arrow_backward'],
    '🔼': ['arrow_up_small'],
    '🔽': ['arrow_down_small'],
    '⏫': ['arrow_double_up'],
    '⏬': ['arrow_double_down'],
    '➡': ['arrow_right'],
    '⬅': ['arrow_left'],
    '⬆': ['arrow_up'],
    '⬇': ['arrow_down'],
    '↗': ['arrow_upper_right'],
    '↘': ['arrow_lower_right'],
    '↙': ['arrow_lower_left'],
    '↖': ['arrow_upper_left'],
    '↕': ['arrow_up_down'],
    '↔': ['left_right_arrow'],
    '🔄': ['arrows_counterclockwise'],
    '↪': ['arrow_right_hook'],
    '↩': ['leftwards_arrow_with_hook'],
    '⤴': ['arrow_heading_up'],
    '⤵': ['arrow_heading_down'],
    '#⃣': ['hash'],
    '*⃣': ['asterisk', 'keycap_asterisk'],
    ℹ: ['information_source'],
    '🔤': ['abc'],
    '🔡': ['abcd'],
    '🔠': ['capital_abcd'],
    '🔣': ['symbols'],
    '🎵': ['musical_note'],
    '🎶': ['notes'],
    '〰': ['wavy_dash'],
    '➰': ['curly_loop'],
    '✔': ['heavy_check_mark'],
    '🔃': ['arrows_clockwise'],
    '➕': ['heavy_plus_sign'],
    '➖': ['heavy_minus_sign'],
    '➗': ['heavy_division_sign'],
    '✖': ['heavy_multiplication_x'],
    '💲': ['heavy_dollar_sign'],
    '💱': ['currency_exchange'],
    '©': ['copyright'],
    '®': ['registered'],
    '™': ['tm'],
    '🔚': ['end'],
    '🔙': ['back'],
    '🔛': ['on'],
    '🔝': ['top'],
    '🔜': ['soon'],
    '☑': ['ballot_box_with_check'],
    '🔘': ['radio_button'],
    '⚪': ['white_circle'],
    '⚫': ['black_circle'],
    '🔴': ['red_circle'],
    '🔵': ['large_blue_circle'],
    '🔸': ['small_orange_diamond'],
    '🔹': ['small_blue_diamond'],
    '🔶': ['large_orange_diamond'],
    '🔷': ['large_blue_diamond'],
    '🔺': ['small_red_triangle'],
    '▪': ['black_small_square'],
    '▫': ['white_small_square'],
    '⬛': ['black_large_square'],
    '⬜': ['white_large_square'],
    '🔻': ['small_red_triangle_down'],
    '◼': ['black_medium_square'],
    '◻': ['white_medium_square'],
    '◾': ['black_medium_small_square'],
    '◽': ['white_medium_small_square'],
    '🔲': ['black_square_button'],
    '🔳': ['white_square_button'],
    '🔈': ['speaker'],
    '🔉': ['sound'],
    '🔊': ['loud_sound'],
    '🔇': ['mute'],
    '📣': ['mega'],
    '📢': ['loudspeaker'],
    '🔔': ['bell'],
    '🔕': ['no_bell'],
    '🃏': ['black_joker'],
    '🀄': ['mahjong'],
    '♠': ['spades'],
    '♣': ['clubs'],
    '♥': ['hearts'],
    '♦': ['diamonds'],
    '🎴': ['flower_playing_cards'],
    '💭': ['thought_balloon'],
    '🗯': ['anger_right', 'right_anger_bubble'],
    '💬': ['speech_balloon'],
    '🕐': ['clock1'],
    '🕑': ['clock2'],
    '🕒': ['clock3'],
    '🕓': ['clock4'],
    '🕔': ['clock5'],
    '🕕': ['clock6'],
    '🕖': ['clock7'],
    '🕗': ['clock8'],
    '🕘': ['clock9'],
    '🕙': ['clock10'],
    '🕚': ['clock11'],
    '🕛': ['clock12'],
    '🕜': ['clock130'],
    '🕝': ['clock230'],
    '🕞': ['clock330'],
    '🕟': ['clock430'],
    '🕠': ['clock530'],
    '🕡': ['clock630'],
    '🕢': ['clock730'],
    '🕣': ['clock830'],
    '🕤': ['clock930'],
    '🕥': ['clock1030'],
    '🕦': ['clock1130'],
    '🕧': ['clock1230'],
    '👁‍🗨': ['eye_in_speech_bubble'],
    '🗨': ['speech_left', 'left_speech_bubble'],
    '⏏': ['eject', 'eject_symbol'],
    '🖤': ['black_heart'],
    '🛑': ['octagonal_sign', 'stop_sign'],
    '🇿': ['regional_indicator_z'],
    '🇾': ['regional_indicator_y'],
    '🇽': ['regional_indicator_x'],
    '🇼': ['regional_indicator_w'],
    '🇻': ['regional_indicator_v'],
    '🇺': ['regional_indicator_u'],
    '🇹': ['regional_indicator_t'],
    '🇸': ['regional_indicator_s'],
    '🇷': ['regional_indicator_r'],
    '🇶': ['regional_indicator_q'],
    '🇵': ['regional_indicator_p'],
    '🇴': ['regional_indicator_o'],
    '🇳': ['regional_indicator_n'],
    '🇲': ['regional_indicator_m'],
    '🇱': ['regional_indicator_l'],
    '🇰': ['regional_indicator_k'],
    '🇯': ['regional_indicator_j'],
    '🇮': ['regional_indicator_i'],
    '🇭': ['regional_indicator_h'],
    '🇬': ['regional_indicator_g'],
    '🇫': ['regional_indicator_f'],
    '🇪': ['regional_indicator_e'],
    '🇩': ['regional_indicator_d'],
    '🇨': ['regional_indicator_c'],
    '🇧': ['regional_indicator_b'],
    '🇦': ['regional_indicator_a'],
    '♾️': ['infinity'],
    '🧡': ['orange_heart'],
    '♀️': ['female'],
    '♂️': ['male'],
    '⚕️': ['staff_of_aesculapius', 'medical_symbol']
  },
  flags: {
    '🇦🇨': ['flag_ac'],
    '🇦🇫': ['flag_af'],
    '🇦🇱': ['flag_al'],
    '🇩🇿': ['flag_dz'],
    '🇦🇩': ['flag_ad'],
    '🇦🇴': ['flag_ao'],
    '🇦🇮': ['flag_ai'],
    '🇦🇬': ['flag_ag'],
    '🇦🇷': ['flag_ar'],
    '🇦🇲': ['flag_am'],
    '🇦🇼': ['flag_aw'],
    '🇦🇺': ['flag_au'],
    '🇦🇹': ['flag_at'],
    '🇦🇿': ['flag_az'],
    '🇧🇸': ['flag_bs'],
    '🇧🇭': ['flag_bh'],
    '🇧🇩': ['flag_bd'],
    '🇧🇧': ['flag_bb'],
    '🇧🇾': ['flag_by'],
    '🇧🇪': ['flag_be'],
    '🇧🇿': ['flag_bz'],
    '🇧🇯': ['flag_bj'],
    '🇧🇲': ['flag_bm'],
    '🇧🇹': ['flag_bt'],
    '🇧🇴': ['flag_bo'],
    '🇧🇦': ['flag_ba'],
    '🇧🇼': ['flag_bw'],
    '🇧🇷': ['flag_br'],
    '🇧🇳': ['flag_bn'],
    '🇧🇬': ['flag_bg'],
    '🇧🇫': ['flag_bf'],
    '🇧🇮': ['flag_bi'],
    '🇨🇻': ['flag_cv'],
    '🇰🇭': ['flag_kh'],
    '🇨🇲': ['flag_cm'],
    '🇨🇦': ['flag_ca'],
    '🇰🇾': ['flag_ky'],
    '🇨🇫': ['flag_cf'],
    '🇹🇩': ['flag_td'],
    '🇨🇱': ['flag_cl'],
    '🇨🇳': ['flag_cn'],
    '🇨🇴': ['flag_co'],
    '🇰🇲': ['flag_km'],
    '🇨🇬': ['flag_cg'],
    '🇨🇩': ['flag_cd'],
    '🇨🇷': ['flag_cr'],
    '🇭🇷': ['flag_hr'],
    '🇨🇺': ['flag_cu'],
    '🇨🇾': ['flag_cy'],
    '🇨🇿': ['flag_cz'],
    '🇩🇰': ['flag_dk'],
    '🇩🇯': ['flag_dj'],
    '🇩🇲': ['flag_dm'],
    '🇩🇴': ['flag_do'],
    '🇪🇨': ['flag_ec'],
    '🇪🇬': ['flag_eg'],
    '🇸🇻': ['flag_sv'],
    '🇬🇶': ['flag_gq'],
    '🇪🇷': ['flag_er'],
    '🇪🇪': ['flag_ee'],
    '🇪🇹': ['flag_et'],
    '🇫🇰': ['flag_fk'],
    '🇫🇴': ['flag_fo'],
    '🇫🇯': ['flag_fj'],
    '🇫🇮': ['flag_fi'],
    '🇫🇷': ['flag_fr'],
    '🇵🇫': ['flag_pf'],
    '🇬🇦': ['flag_ga'],
    '🇬🇲': ['flag_gm'],
    '🇬🇪': ['flag_ge'],
    '🇩🇪': ['flag_de'],
    '🇬🇭': ['flag_gh'],
    '🇬🇮': ['flag_gi'],
    '🇬🇷': ['flag_gr'],
    '🇬🇱': ['flag_gl'],
    '🇬🇩': ['flag_gd'],
    '🇬🇺': ['flag_gu'],
    '🇬🇹': ['flag_gt'],
    '🇬🇳': ['flag_gn'],
    '🇬🇼': ['flag_gw'],
    '🇬🇾': ['flag_gy'],
    '🇭🇹': ['flag_ht'],
    '🇭🇳': ['flag_hn'],
    '🇭🇰': ['flag_hk'],
    '🇭🇺': ['flag_hu'],
    '🇮🇸': ['flag_is'],
    '🇮🇳': ['flag_in'],
    '🇮🇩': ['flag_id'],
    '🇮🇷': ['flag_ir'],
    '🇮🇶': ['flag_iq'],
    '🇮🇪': ['flag_ie'],
    '🇮🇱': ['flag_il'],
    '🇮🇹': ['flag_it'],
    '🇨🇮': ['flag_ci'],
    '🇯🇲': ['flag_jm'],
    '🇯🇵': ['flag_jp'],
    '🇯🇪': ['flag_je'],
    '🇯🇴': ['flag_jo'],
    '🇰🇿': ['flag_kz'],
    '🇰🇪': ['flag_ke'],
    '🇰🇮': ['flag_ki'],
    '🇽🇰': ['flag_xk'],
    '🇰🇼': ['flag_kw'],
    '🇰🇬': ['flag_kg'],
    '🇱🇦': ['flag_la'],
    '🇱🇻': ['flag_lv'],
    '🇱🇧': ['flag_lb'],
    '🇱🇸': ['flag_ls'],
    '🇱🇷': ['flag_lr'],
    '🇱🇾': ['flag_ly'],
    '🇱🇮': ['flag_li'],
    '🇱🇹': ['flag_lt'],
    '🇱🇺': ['flag_lu'],
    '🇲🇴': ['flag_mo'],
    '🇲🇰': ['flag_mk'],
    '🇲🇬': ['flag_mg'],
    '🇲🇼': ['flag_mw'],
    '🇲🇾': ['flag_my'],
    '🇲🇻': ['flag_mv'],
    '🇲🇱': ['flag_ml'],
    '🇲🇹': ['flag_mt'],
    '🇲🇭': ['flag_mh'],
    '🇲🇷': ['flag_mr'],
    '🇲🇺': ['flag_mu'],
    '🇲🇽': ['flag_mx'],
    '🇫🇲': ['flag_fm'],
    '🇲🇩': ['flag_md'],
    '🇲🇨': ['flag_mc'],
    '🇲🇳': ['flag_mn'],
    '🇲🇪': ['flag_me'],
    '🇲🇸': ['flag_ms'],
    '🇲🇦': ['flag_ma'],
    '🇲🇿': ['flag_mz'],
    '🇲🇲': ['flag_mm'],
    '🇳🇦': ['flag_na'],
    '🇳🇷': ['flag_nr'],
    '🇳🇵': ['flag_np'],
    '🇳🇱': ['flag_nl'],
    '🇳🇨': ['flag_nc'],
    '🇳🇿': ['flag_nz'],
    '🇳🇮': ['flag_ni'],
    '🇳🇪': ['flag_ne'],
    '🇳🇬': ['flag_ng'],
    '🇳🇺': ['flag_nu'],
    '🇰🇵': ['flag_kp'],
    '🇳🇴': ['flag_no'],
    '🇴🇲': ['flag_om'],
    '🇵🇰': ['flag_pk'],
    '🇵🇼': ['flag_pw'],
    '🇵🇸': ['flag_ps'],
    '🇵🇦': ['flag_pa'],
    '🇵🇬': ['flag_pg'],
    '🇵🇾': ['flag_py'],
    '🇵🇪': ['flag_pe'],
    '🇵🇭': ['flag_ph'],
    '🇵🇱': ['flag_pl'],
    '🇵🇹': ['flag_pt'],
    '🇵🇷': ['flag_pr'],
    '🇶🇦': ['flag_qa'],
    '🇷🇴': ['flag_ro'],
    '🇷🇺': ['flag_ru'],
    '🇷🇼': ['flag_rw'],
    '🇸🇭': ['flag_sh'],
    '🇰🇳': ['flag_kn'],
    '🇱🇨': ['flag_lc'],
    '🇻🇨': ['flag_vc'],
    '🇼🇸': ['flag_ws'],
    '🇸🇲': ['flag_sm'],
    '🇸🇹': ['flag_st'],
    '🇸🇦': ['flag_sa'],
    '🇸🇳': ['flag_sn'],
    '🇷🇸': ['flag_rs'],
    '🇸🇨': ['flag_sc'],
    '🇸🇱': ['flag_sl'],
    '🇸🇬': ['flag_sg'],
    '🇸🇰': ['flag_sk'],
    '🇸🇮': ['flag_si'],
    '🇸🇧': ['flag_sb'],
    '🇸🇴': ['flag_so'],
    '🇿🇦': ['flag_za'],
    '🇰🇷': ['flag_kr'],
    '🇪🇸': ['flag_es'],
    '🇱🇰': ['flag_lk'],
    '🇸🇩': ['flag_sd'],
    '🇸🇷': ['flag_sr'],
    '🇸🇿': ['flag_sz'],
    '🇸🇪': ['flag_se'],
    '🇨🇭': ['flag_ch'],
    '🇸🇾': ['flag_sy'],
    '🇹🇼': ['flag_tw'],
    '🇹🇯': ['flag_tj'],
    '🇹🇿': ['flag_tz'],
    '🇹🇭': ['flag_th'],
    '🇹🇱': ['flag_tl'],
    '🇹🇬': ['flag_tg'],
    '🇹🇴': ['flag_to'],
    '🇹🇹': ['flag_tt'],
    '🇹🇳': ['flag_tn'],
    '🇹🇷': ['flag_tr'],
    '🇹🇲': ['flag_tm'],
    '🇹🇻': ['flag_tv'],
    '🇺🇬': ['flag_ug'],
    '🇺🇦': ['flag_ua'],
    '🇦🇪': ['flag_ae'],
    '🇬🇧': ['flag_gb', 'flag_uk', 'britain', 'united_kingdom'],
    '🇺🇸': ['flag_us', 'united_states'],
    '🇻🇮': ['flag_vi'],
    '🇺🇾': ['flag_uy'],
    '🇺🇿': ['flag_uz'],
    '🇻🇺': ['flag_vu'],
    '🇻🇦': ['flag_va'],
    '🇻🇪': ['flag_ve'],
    '🇻🇳': ['flag_vn'],
    '🇼🇫': ['flag_wf'],
    '🇪🇭': ['flag_eh'],
    '🇾🇪': ['flag_ye'],
    '🇿🇲': ['flag_zm'],
    '🇿🇼': ['flag_zw'],
    '🇷🇪': ['flag_re'],
    '🇦🇽': ['flag_ax'],
    '🇹🇦': ['flag_ta'],
    '🇮🇴': ['flag_io'],
    '🇧🇶': ['flag_bq'],
    '🇨🇽': ['flag_cx'],
    '🇨🇨': ['flag_cc'],
    '🇬🇬': ['flag_gg'],
    '🇮🇲': ['flag_im'],
    '🇾🇹': ['flag_yt'],
    '🇳🇫': ['flag_nf'],
    '🇵🇳': ['flag_pn'],
    '🇧🇱': ['flag_bl'],
    '🇵🇲': ['flag_pm'],
    '🇬🇸': ['flag_gs'],
    '🇹🇰': ['flag_tk'],
    '🇧🇻': ['flag_bv'],
    '🇭🇲': ['flag_hm'],
    '🇸🇯': ['flag_sj'],
    '🇺🇲': ['flag_um'],
    '🇮🇨': ['flag_ic'],
    '🇪🇦': ['flag_ea'],
    '🇨🇵': ['flag_cp'],
    '🇩🇬': ['flag_dg'],
    '🇦🇸': ['flag_as'],
    '🇦🇶': ['flag_aq'],
    '🇻🇬': ['flag_vg'],
    '🇨🇰': ['flag_ck'],
    '🇨🇼': ['flag_cw'],
    '🇪🇺': ['flag_eu'],
    '🇬🇫': ['flag_gf'],
    '🇹🇫': ['flag_tf'],
    '🇬🇵': ['flag_gp'],
    '🇲🇶': ['flag_mq'],
    '🇲🇵': ['flag_mp'],
    '🇸🇽': ['flag_sx'],
    '🇸🇸': ['flag_ss'],
    '🇹🇨': ['flag_tc'],
    '🇲🇫': ['flag_mf'],
    '🏳️‍🌈': ['gay_pride_flag', 'rainbow_flag'],
    '🏴󠁧󠁢󠁥󠁮󠁧󠁿': ['flag_eng', 'flag_en', 'england'],
    '🏴󠁧󠁢󠁳󠁣󠁴󠁿': ['flag_sct', 'scotland'],
    '🏴󠁧󠁢󠁷󠁬󠁳󠁿': ['flag_wls', 'wales'],
    '🏴‍☠️': ['pirate_flag', 'pirate', 'jolly_roger'],
    '🇺🇳': ['flag_un', 'united_nations']
  }
}

export interface Emoji {
  category: string
  emoji: string
  keywords: string[]
}

export const emojis: Emoji[] = []

export const iterate = (
  iteratee: ({ category, keywords, emoji }: Emoji) => void
) =>
  Object.keys(categoryMap).forEach(category => {
    const emojis = categoryMap[category]

    Object.keys(emojis).forEach(emoji => {
      const keywords = emojis[emoji]

      iteratee({ category, keywords, emoji })
    })
  })

iterate(emoji => emojis.push(emoji))

export default categoryMap



// WEBPACK FOOTER //
// ./src/modules/styled-elements/Emoji/emojiMap.ts